import { query, queryAll, ready } from "./dom";

const elements = {
  openLinks: () => queryAll(".js-content-card-link"),
};

const onContentCardLinkClick = (event) => {
  const details = event.target.parentNode;
  const id = details.id;
  const isOpening = !details.open;
  if (!isOpening) return;

  location.hash = `#${id}`;
};

export const setup = () => {
  for (const openLink of elements.openLinks()) {
    openLink.addEventListener("click", onContentCardLinkClick);
  }
  ready(() => {
    const hash = location.hash.replace("#", "");
    if (!hash) return;

    const details = query(`#${hash}`);
    details.open = true;
  });
};
